import React from 'react';

const DEFAULT_SIZE = 25;
const DEFAULT_STROKE_COLOR = '#000000';
const DEFAULT_BACKGROUND_COLOR = '#ffffff';

function MarkerWithBadge({
  MarkerComponent,
  size,
  backgroundColor,
  borderColor,
  textColor,
  color,
  strokeColor,
  badgeContent = null,
  ...others
}) {
  const marker = (
    <MarkerComponent
      size={size}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      textColor={textColor}
      color={color}
      strokeColor={strokeColor}
      {...others}
    />
  );

  if (badgeContent == null || badgeContent === '') {
    return marker;
  }

  const badgeRadius = 8;
  const numericSize = Number(size) || DEFAULT_SIZE;

  const containerWidth = numericSize + badgeRadius;
  const containerHeight = numericSize + badgeRadius;

  const badgeCx = numericSize;
  const badgeCy = badgeRadius;

  const badgeTextAndBorderColor = textColor || borderColor || strokeColor || DEFAULT_STROKE_COLOR;
  const badgeBackgroundColor = backgroundColor || color || DEFAULT_BACKGROUND_COLOR;

  return (
    <svg 
      className="badged-marker-svg"
      width={containerWidth} 
      height={containerHeight} 
      overflow="visible" 
      xmlns="http://www.w3.org/2000/svg">
      <g transform={`translate(0, ${badgeRadius})`}>{marker}</g>
      <g transform={`translate(${badgeCx}, ${badgeCy})`}>
        <circle
          r={badgeRadius}
          fill={badgeBackgroundColor}
          stroke={badgeTextAndBorderColor}
          strokeWidth="1"
        />
        <text
          x="0"
          y="0"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="10"
          fill={badgeTextAndBorderColor}>
          {badgeContent}
        </text>
      </g>
    </svg>
  );
}

export default MarkerWithBadge;